export default {
  '4ca1cd68d79c56f0d72ad2e4cc4f3476': 'Applicable to',
  dcd9d382aa0f58e928873c76e917ebeb: 'Free lessons',
  baa57d150eefb7707e7557bfb939707b: 'Gift with purchase',
  '89d77943b4c04ee218cb23c721c52254': 'Tangible goods',
  '705f3627acdd1ed5403129cac4705f9b': 'Friend card',
  '51c07086aeb9ff99a953b899e44054a9': 'Offer a one-month course to your friends for a limited time'
};
